import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import { isContentstackEnabled } from 'yoda-site-components/lib/cms-renderer/utils';
import { PreviewCMSRouter } from 'yoda-site-components/lib/cms-renderer/preview';
import Iris from './Iris';
import Contentstack from './Contentstack';
import { CONTENTSTACK_DEFAULT_PAGE_LIST } from '../../../helper/constants/constantPagelist';

function Marketing(props) {
    const {
        enableContentstackCMS,
        inclusionPagelist,
        exclusionPagelist,
        location,
        isPreview,
        enablePreviewCMSSwitcher,
        enableContentstackInclusionList,
    } = props;

    // Regular flow — untouched
    if (!enablePreviewCMSSwitcher || !isPreview) {
        if (
            isContentstackEnabled(
                enableContentstackCMS,
                location,
                inclusionPagelist,
                exclusionPagelist,
                CONTENTSTACK_DEFAULT_PAGE_LIST,
                enableContentstackInclusionList
            )
        ) {
            return <Contentstack {...props} />;
        }
        return <Iris {...props} />;
    }

    // Preview CMS-switcher flow. Evergreen here is the /m/evergreen slug served
    // via IRIS, so no EvergreenComponent is injected (degrades to IRIS).
    // defaultPageList carries the brand default list so the switcher's routing
    // matches the regular flow above (both feed isContentstackEnabled the same
    // CONTENTSTACK_DEFAULT_PAGE_LIST).
    return (
        <PreviewCMSRouter
            {...props}
            IrisComponent={Iris}
            ContentstackComponent={Contentstack}
            defaultPageList={CONTENTSTACK_DEFAULT_PAGE_LIST}
        />
    );
}

const mapStateToProps = ({ context }) => {
    const featureFlags = get(context, 'featureFlags', {});
    const preferences = get(context, 'preferences', {});

    return {
        context,
        isPreview: get(context, 'isPreview', false),
        enablePreviewCMSSwitcher: featureFlags.enablePreviewCMSSwitcher || false,
        enableContentstackCMS: featureFlags.enableContentstackCMS || false,
        enableContentstackInclusionList: featureFlags.enableContentstackInclusionList || false,
        inclusionPagelist: get(preferences, 'contentstack.inclusionPageList', []),
        exclusionPagelist: get(
            preferences,
            'contentstack.exclusionPageList',
            []
        ),
        previewStartDate: get(preferences, 'contentstack.previewStartDate', ''),
    };
};

export default withRouter(connect(mapStateToProps)(Marketing));
